import fl3Img from './Assets/floor3.png';
import fl4Img from './Assets/floor4.png'
import fl5Img from './Assets/floor5.png'
import fl6Img from './Assets/floor6.png'
import fl7Img from './Assets/floor7.jpg'
import fl8Img from './Assets/floor8.jpg'
import fl9Img from './Assets/floor 9 demo.png'
import fl10Img from './Assets/floor10demo.png'
import fl11Img from './Assets/floor10demo.png'
import fl12Img from './Assets/floor10demo.png'
export const floorListData = [
  {
    title: 'Floor 1 - The Foundation',
    imagePath: '../Assets/floor3.png',
    release: 'July 6, 2021',
    import: '',
    number: 1,
    desc: 'Only Available on Instagram'
  },
  {
    title: 'Floor 2 - Don\'t Overthink',
    imagePath: '../Assets/floor3.png',
    release: 'August 22, 2021',
    import: '',
    number: 2,
    desc: 'Only Available on Instagram'
  },
  {
    title: 'Floor 3 - The Site',
    imagePath: '../Assets/floor3.png',
    import: fl3Img,
    release: 'December 30, 2021',
    number: 3,
    desc: 'You are here. This IS the "The Site".'
  },
  {
    title: 'Floor 4 - D.O.A',
    imagePath: '../Assets/floor4.png',
    import: fl4Img,
    release: 'Janurary 14, 2022',
    number: 4,
    desc: '6 Song EP : ACCESSTOTHEINTERNET'
  },
  {
    title: 'Floor 5 - Three Paintings',
    imagePath: '../Assets/floor5.png',
    import: fl5Img,
    release: 'March 10, 2022',
    number: 5,
    desc: 'Biblical Inspired Acrylic Paintings'
  },
  {
    title: 'Floor 6 - A Duel - Short Film',
    imagePath: '../Assets/floor6.png',
    import: fl6Img,
    release: 'April 30, 2022',
    number: 6,
    desc: 'Short film - created in one day'
  },
  {
    title: 'Floor 7 - The Art of Minecraft',
    imagePath: '../Assets/floor7.jpg',
    import: fl7Img,
    release: 'June 22, 2023',
    number: 7,
    desc: 'Investigation into the beauty in Minecraft'
  },
  {
    title: 'Floor 8 - Flowers and Showers (Symphony No 5)',
    imagePath: '../Assets/floor8.jpg',
    import: fl8Img,
    release: 'June 29, 2023',
    number: 8,
    desc: 'Learning Piano'
  },
  {
    title: 'Floor 9 - Back to Sketching',
    imagePath: '../Assets/floor%209%20demo.png',
    import: fl9Img,
    release: 'October 17, 2024',
    number: 9,
    desc: ''
  },
  {
    title: 'Floor 10 - MotivMate iOS',
    imagePath: '../Assets/floor10demo.png',
    import: fl10Img,
    release: 'unreleased',
    number: 10,
    desc: 'Learning Full Stack React Native'
  },
    {
    title: 'Floor 11 - BMW E24',
    imagePath: '../Assets/floor10demo.png',
    import: fl11Img,
    release: 'unreleased',
    number: 11,
    desc: 'An old dream car'
  },
  {
    title: 'Floor 12 - Mead',
    imagePath: '../Assets/floor10demo.png',
    import: fl12Img,
    release: 'unreleased',
    number: 12,
    desc: 'Brewing Mead'
  },
    {
    title: 'Floor 13 - Zine',
    imagePath: '../Assets/floor10demo.png',
    import: fl12Img,
    release: 'unreleased',
    number: 13,
    desc: 'The story of 64 - Zine'
  },
];
